import type { ReadSearchApiArg } from 'lib-search-types';
import { filterFieldCatalogue, filterOperatorCatalogue } from 'lib-search-ui';
import { memo, useMemo } from 'react';

import { SearchScopeFilter } from 'components/search';

import { useSearchQuickFilter } from '../../utils/useSearchQuickFilter';

export const SearchQueueQuickFilter = memo(
  function SearchQueueQuickFilter(): JSX.Element {
    const { condition, handleChange } = useSearchQuickFilter('queue_id');

    const initialArg = useMemo(
      (): ReadSearchApiArg<'queues'> => ({
        scope: 'queues',
        sortBy: { field: 'name', order: 'asc' },
      }),
      [],
    );

    return (
      <SearchScopeFilter
        scope="queues"
        placeholder="Search queues..."
        operators={filterOperatorCatalogue.conversations.queue_id.operators}
        defaultOperator={
          filterOperatorCatalogue.conversations.queue_id.defaultOperator
        }
        selectedValues={condition?.values}
        selectedOperator={condition?.operator}
        initialArg={initialArg}
        onChange={handleChange}
      >
        {filterFieldCatalogue.conversations.queue_id.label}
      </SearchScopeFilter>
    );
  },
);
